// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_51-0";
export var eligibilityCardNotEligible = "_51-1";